import { render, staticRenderFns } from "./ed-designer-elements.component.vue?vue&type=template&id=03cdb3f2&scoped=true&"
import script from "./ed-designer-elements.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-elements.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-elements.component.scss?vue&type=style&index=0&id=03cdb3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdb3f2",
  null
  
)

export default component.exports